import type React from 'react';
import { useState, useEffect, useRef } from 'react';
import PickupLocation from '../../components/pickup-location/PickupLocation';
import Availability from '../../components/availability/Availability';
import { useAppDispatch } from '../../app/hooks';
import { setProgressStep } from '../../redux/progress-bar/progressBar';
import scrollToComponent from 'react-scroll-to-component';

const LessonSearch: React.FC = () => {
    
    const [showAvailability, setShowAvailability] = useState(false);
    const availabilityRef = useRef<React.ElementRef<typeof Availability> | null>(null);
    const dispatch = useAppDispatch();

    // Scroll to availability when `showAvailability` changes
    useEffect(() => {
        if (showAvailability && availabilityRef.current) {
            scrollToComponent(availabilityRef.current, { align: 'top' });
        }
    }, [showAvailability]);

    // Set progress step and push app event data on mount
    useEffect(() => {
        dispatch(setProgressStep({ step: 2 }));

        const appEventData = 'AppEventData';
        // Extend the Window interface to include appEventData
        interface CustomWindow extends Window {
            AppEventData?: { push: (event: any) => void };
        }
        const customWindow = window as CustomWindow;
        customWindow[appEventData]?.push({
                    event: 'stepLoaded',
                    page: {
                        pageName: 'ie:secure:my-aviva:driving-school:lesson-search',
                        channel: 'secure',
                    },
                });
    }, [dispatch]);

    const onSearch = () => {
        setShowAvailability(true);
    };

    const resetAvailableTime = () => {
        setShowAvailability(false);
    };

    return (
        <div data-testid="lesson-search-container">
            <h1 className="text__center">Select pickup location</h1>
            <p className="text__center">
                Tell us your preferred pickup location and we will show you the next available date and time
            </p>
            <PickupLocation
                onSearch={onSearch}
                resetAvailableTime={resetAvailableTime}
            />
            {showAvailability && (
                <Availability ref={availabilityRef} />
            )}
        </div>
    );
};

export default LessonSearch;